// extracted by mini-css-extract-plugin
export var container = "Map-module--container--2fee4";
export var counter = "Map-module--counter--3d78e";
export var marker = "Map-module--marker--d61be";
export var popup = "Map-module--popup--781cd";